import axios from 'axios'
import router from "@/router";
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_MEETYOU_EN_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["Authorization"] = "Bearer " + getToken();
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.config.responseType === 'blob') {
      return {
        content: response.data
      }
    }
    const res = response.data
    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      if (res.code != 118) {
        Message({
          message: res.msg || "Error",
          type: "error",
          duration: 3 * 1000
        });
      }
      if (res.code == 127 || res.code == 116 || res.code == 117) {
        // 登录失效，请重新登录
        // setTimeout(() => {
        //   store.dispatch("user/resetToken")
        //   store.dispatch("user/logout");
        //   router.push({
        //     path: "/login"
        //   });
        //   location.reload();
        // }, 1000);
        store.dispatch("user/resetToken")
          store.dispatch("user/logout");
          router.push({
            path: "/login"
          });
      } else if (res.code == 118) {
        // 登录者无权操作
        router.push({
          path: "/403"
        });
      }else if (res.code == 199) {
        // 用户被锁定
        store.dispatch("user/logout");
        router.push({
          path: "/login"
        });
      }
      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
